import { useCallback } from 'react';

import { ICONS, ICON_TYPES } from '@/src/components/common/Elements/Icon/Icon';
import { ACTION_POSITIONS, MODAL_TYPE } from '@/src/components/common/Elements/Modal/Config';
import useConfirmPopup from '@/src/components/common/Elements/Modal/useConfirmPopup';

import { useTreatments } from '../../../../store/treatments.store';

const useDiscardSupplier = () => {
  const [DiscardDraftSupplierModal, confirmDraftSupplierDiscard] = useConfirmPopup({
    classNames: '',
    modalWidth: '600px',
    modalType: MODAL_TYPE.danger,
    actionPosition: ACTION_POSITIONS.between,
    title: 'Discard draft supplier?',
    icon: {
      icon: ICONS.error_outline,
      iconType: ICON_TYPES.outlined,
      className: '!tw-text-cfo-red-400',
    },
    message: `This action cannot be undone.`,
    confirmBtn: { label: 'Yes, discard' },
  });

  const { onDiscardDetectedVendor } = useTreatments();

  const handlePrompDiscard = useCallback(
    async (e?: React.MouseEvent) => {
      if (e) {
        e.stopPropagation();
      }

      if (!(await confirmDraftSupplierDiscard())) {
        return false;
      }

      onDiscardDetectedVendor();

      return true;
    },
    [confirmDraftSupplierDiscard, onDiscardDetectedVendor]
  );

  return {
    confirmDraftSupplierDiscard,
    DiscardDraftSupplierModal,
    onPromptDiscard: handlePrompDiscard,
  };
};

export default useDiscardSupplier;
